import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/plugins/naver/pay";

export const pay = {
    // ...example,
    order(data){
        return axios.post(`${url}/order`, data).then(result => result.data);
    },
}
